import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import Home from './pages/Home/Home';
import About from './pages/About/About';
import Services from './pages/Services/Services';
import Careers from './pages/Careers/Careers';
import Contact from './pages/Contact/Contact';
import Inception from './pages/Inception/Inception';
import Ventures from './pages/Ventures/Ventures';
import One from './pages/One/One';
import './App.css';

function App() {
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const handleMouseMove = (e) => {
      setMousePosition({ x: e.clientX, y: e.clientY });
    };

    const isDesktop = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (isDesktop) {
      window.addEventListener('mousemove', handleMouseMove);
    }

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);

  return (
    <Router>
      <div className="App">
        <div 
          className="custom-cursor"
          style={{
            left: mousePosition.x,
            top: mousePosition.y
          }}
        ></div>
        <Header />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/inception" element={<Inception />} />
            <Route path="/ventures" element={<Ventures />} />
            <Route path="/one" element={<One />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}
export default App;